import script from "./RoleMapping.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleMapping.vue?vue&type=script&setup=true&lang=js"

import "./RoleMapping.vue?vue&type=style&index=0&id=476aab32&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-476aab32"]])

export default __exports__